// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover_cover__25LtH","coverContainer":"cover_coverContainer__2Mfwd","coverInner":"cover_coverInner__16zaI","coverHeading":"cover_coverHeading__1cfHn"};